// FormSections.jsx
import React from "react";

import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
import DrSearchDropDown from "../BranchSearchDropDown/DrSearchDropDown";
import BranchSearchDropdown from "../BranchSearchDropDown/BranchSearchDropDown";
import CheckUsername from "./CheckUserName";
import MultiRoleSelectForm from "../../booking/RoleSelectForm";
import { DI_ADMIN, ROLE_ADMIN } from "../visitConstant/ApiConstant";

// Patient Basic Information Section
export const PatientBasicInfo = ({
  user,
  handleChange,
  nameOptions,
  mobileOptions,
  loading,
  onSelect,
  setNameInput,
  nameInput,
  setMobileInput,
  mobileInput,
  handleAddNewItem,
}) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Basic Information</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="patientName" className="form-label">
              Patient Name*
            </label>
            <div className="row g-2">
              <div className="col-3">
                <select
                  className="form-select"
                  name="customerId.salutation"
                  onChange={handleChange}
                  value={user?.customerId?.salutation || ""}
                >
                  <option value="" disabled>
                    Title
                  </option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                  <option value="md">Md</option>
                  <option value="Smt">Smt</option>
                  <option value="Baby">Baby</option>
                  <option value="Sri">Sri</option>
                </select>
              </div>
              <div className="col-9">
                <UserSearchDropdown
                  options={nameOptions}
                  handleInputChange={setNameInput}
                  onSelect={onSelect}
                  value={user?.customerId?.name}
                  rowIndex={1}
                  loading={loading}
                  Placeholder="Enter Name"
                  onAddNewItem={(name) =>
                    handleAddNewItem("customerId.name", name)
                  }
                  searchTerm={nameInput}
                  newEntry={true}
                />
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="phoneNumber" className="form-label">
              Phone Number*
            </label>
            <UserSearchDropdown
              options={mobileOptions}
              handleInputChange={setMobileInput}
              onSelect={onSelect}
              value={user?.customerId?.mobileNo}
              rowIndex={1}
              loading={loading}
              Placeholder="Enter Number"
              onAddNewItem={(mobileNo) =>
                handleAddNewItem("customerId.mobileNo", mobileNo)
              }
              searchTerm={mobileInput}
              newEntry={true}
              inputType="tel"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Gender and Age Section
export const GenderAgeSection = ({
  user,
  handleChange,
  selectedGender,
  handleGenderChange,
  dob,
  setDOB,
}) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Gender & Age</h5>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">Gender*</label>
            <div className="btn-group w-100" role="group">
              <input
                type="radio"
                className="btn-check"
                name="customerId.gender"
                id="genderMale"
                value="M"
                checked={selectedGender === "M"}
                onChange={handleGenderChange}
              />
              <label className="btn btn-outline-primary" htmlFor="genderMale">
                M
              </label>
              <input
                type="radio"
                className="btn-check"
                name="customerId.gender"
                id="genderFemale"
                value="F"
                checked={selectedGender === "F"}
                onChange={handleGenderChange}
              />
              <label className="btn btn-outline-primary" htmlFor="genderFemale">
                F
              </label>
              <input
                type="radio"
                className="btn-check"
                name="customerId.gender"
                id="genderOther"
                value="T"
                checked={selectedGender === "T"}
                onChange={handleGenderChange}
              />
              <label className="btn btn-outline-primary" htmlFor="genderOther">
                Other
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="age" className="form-label">
              Age
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="age"
                placeholder="Age"
                name="customerId.age"
                onChange={handleChange}
                value={user?.customerId?.age || ""}
                min="1"
                max="120"
              />
              <select
                className="form-select"
                name="customerId.ageUnit"
                onChange={handleChange}
                value={user?.customerId?.ageUnit || "years"}
              >
                <option value="years">Years</option>
                <option value="months">Months</option>
                <option value="day">Days</option>
              </select>
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="dob" className="form-label">
              DOB
            </label>
            <input
              type="date"
              className="form-control"
              id="dob"
              value={dob}
              onChange={(e) => setDOB(e.target.value)}
            />
          </div>

          {/* <div className="col-md-3">
            <label className="form-label">OPD</label>
            <DrSearchDropDown
              onSelect={(e) => {
                handleChange({
                  target: {
                    name: "opd",
                    value: e?.hospitalDoctorID,
                  },
                });
              }}
              hospitalId={0}
              type="docotor"
              branchId={1}
              onChange={handleChange}
              value={user?.opd}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

// Doctor Type Section
export const DoctorTypeSection = ({ user, handleChange }) => {

  console.log(user?.customerId?.type ,"user?.customerId?.type");
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Type & Specialization</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Type*</label>
            {/* <div className="btn-group w-100" role="group">
              {["General", "Specialization"].map((type, index) => (
                <React.Fragment key={type}>
                  <input
                    type="radio"
                    className="btn-check"
                    name="customerId.type"
                    id={`type${type}`}
                    value={type}
                    checked={user?.customerId?.type === type}
                    // onChange={handleChange}
                    onChange={(value) => console.log(value.target.value)}
                    // value={type == 1 ? "General" : "Specialization"}
                  />

                  <label
                    className="btn btn-outline-primary"
                    htmlFor={`type${type}`}
                  >
                    {type}
                  </label>
                </React.Fragment>
              ))}
            </div> */}
            <div className="btn-group w-100" role="group">
              {["General", "Specialization"].map((type, index) => (
                <React.Fragment key={type}>
                  <input
                    type="radio"
                    className="btn-check"
                    name="customerId.type"
                    id={`type${index}`}
                    value={index}
                    checked={user?.customerId?.type === index}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "customerId.type",
                          value: parseInt(e.target.value, 10),
                        },
                      })
                    }
                  />
                  <label
                    className={`btn btn-outline-primary ${
                      user?.customerId?.type === index ? "active" : ""
                    }`}
                    htmlFor={`type${index}`}
                  >
                    {type}
                  </label>
                </React.Fragment>
              ))}
            </div>

            {/* <div className="btn-group w-100" role="group">
              {["General", "Specialization"].map((type, index) => (
                <React.Fragment key={type}>
                  <input
                    type="radio"
                    className="btn-check"
                    name="customerId.type"
                    id={`type${index}`}
                    value={index} // Use array index as value (0 or 1)
                    checked={user?.customerId?.type}
                    onChange={handleChange}
                  />
                
                  <label
                    className={`btn btn-outline-primary ${
                      user?.customerId?.type === index ? "active" : ""
                    }`}
                    htmlFor={`type${index}`}
                  >
                    {type}
                  </label>
                </React.Fragment>
              ))}
            </div> */}
          </div>

          <div className="col-md-6">
            <label className="form-label">Registration Number</label>
            <input
              type="text"
              name="customerId.registrationNo"
              value={user?.customerId?.registrationNo || ""}
              onChange={handleChange}
              className="form-control"
              placeholder="Registration Number"
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Registration Date</label>
            <input
              type="date"
              name="customerId.registrationDate"
              value={user?.customerId?.registrationDate || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {user.customerId?.type == 1 && (
            <div className="col-md-6">
              <label className="form-label">Specialization*</label>
              <input
                type="text"
                name="customerId.specialization"
                value={user?.customerId?.specialization || ""}
                onChange={handleChange}
                className="form-control"
                placeholder="Your specialization"
                required
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Credentials Section
export const CredentialsSection = ({
  user,
  handleChange,
  handleBranchSelection,
  confirmPassword,
  setConfirmPassword,

  hospitalId,
  BaranchId,
  Role,
}) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Credentials & Branch</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Branch*</label>
            <BranchSearchDropdown
              hospitalId={hospitalId}
              onSelect={(e) => handleBranchSelection(e)}
              selectedBranchId={user?.customerId?.branchId}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Username*</label>

            <CheckUsername
              name={"customerId.username"}
              value={user?.customerId?.username}
              handleChange={handleChange}
            />

          
          </div>

          <div className="col-md-6">
            <label className="form-label">Password*</label>
            <input
              type="text"
              name="customerId.password"
             // value={user?.customerId?.password || ""}
              onChange={handleChange}
              className="form-control"
              placeholder="Password"
              required
            />
          </div>

          {Role?.includes(DI_ADMIN) && (
            <MultiRoleSelectForm
              name={"customerId.role"}
              user={user?.customerId?.role}
              handleRoleChange={(
                data //console.log(data)
              ) => handleChange(data)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

// Patient Contact Information
export const PatientContactInfo = ({ user, handleChange, role, constants }) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Contact Information</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="city" className="form-label">
              City
            </label>
            <input
              type="text"
              name="customerId.city"
              className="form-control"
              id="city"
              placeholder="Enter City"
              onChange={handleChange}
              value={user?.customerId?.city || ""}
            />
          </div>

          <div className="col-md-3">
            <label htmlFor="pin" className="form-label">
              Pin
            </label>
            <input
              name="customerId.pin"
              type="text"
              className="form-control"
              id="pin"
              placeholder="Enter Pin"
              onChange={handleChange}
              value={user.customerId?.pin || ""}
            />
          </div>

          <div className="col-md-3">
            <label htmlFor="preferredLanguage" className="form-label">
              Language
            </label>
            <select
              className="form-select"
              id="preferredLanguage"
              name="customerId.preferredLanguage"
              onChange={handleChange}
              value={user?.customerId?.preferredLanguage || "English"}
            >
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Marathi">Marathi</option>
            </select>
          </div>

          <div className="col-md-6">
            <label htmlFor="address" className="form-label">
              Address
            </label>
            <textarea
              name="customerId.address"
              className="form-control"
              id="address"
              placeholder="Enter Address"
              onChange={handleChange}
              value={user.customerId?.address || ""}
              rows="3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Additional Details Section (expanded details)
export const AdditionalDetailsSection = ({
  user,
  handleChange,
  handleSubmit,
}) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Additional Details</h5>

        {/* Marital Status Section */}
        <div className="mb-4">
          <h6 className="border-bottom pb-2 mb-3">Marital Status</h6>
          <div className="row g-3">
            <div className="col-md-4">
              <label htmlFor="maritalStatus" className="form-label">
                Marital Status
              </label>
              <select
                name="customerId.customerDetails.maritalStatus"
                className="form-select"
                id="maritalStatus"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.maritalStatus || ""}
              >
                <option value="">Select</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="since" className="form-label">
                Since
              </label>
              <input
                type="date"
                className="form-control"
                name="customerId.customerDetails.since"
                id="since"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.since || ""}
              />
            </div>

            <div className="col-md-4">
              <label htmlFor="bloodGroup" className="form-label">
                Blood Group
              </label>
              <select
                name="customerId.customerDetails.bloodGroup"
                className="form-select"
                id="bloodGroup"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.bloodGroup || ""}
              >
                <option value="">Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
            </div>
          </div>

          <div className="row g-3 mt-2">
            <div className="col-md-6">
              <label htmlFor="spouseName" className="form-label">
                Spouse Name
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.spouseName"
                id="spouseName"
                placeholder="Enter Spouse Name"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.spouseName || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="spouseBloodGroup" className="form-label">
                Spouse Blood Group
              </label>
              <select
                name="customerId.customerDetails.spouseBloodGroup"
                className="form-select"
                id="spouseBloodGroup"
                onChange={handleChange}
                value={
                  user?.customerId?.customerDetails?.spouseBloodGroup || ""
                }
              >
                <option value="">Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
            </div>
          </div>
        </div>

        {/* Referral & Identification Section */}
        <div className="mb-4">
          <h6 className="border-bottom pb-2 mb-3">Referral & Identification</h6>
          <div className="row g-3">
            {/* <div className="col-md-6">
              <label htmlFor="referredBy" className="form-label">
                Referred By
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.referredBy"
                id="referredBy"
                placeholder="Doctor Name"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.referredBy || ""}
              />
            </div> */}

            <div className="col-md-6">
              <label htmlFor="existingID" className="form-label">
                Existing ID (if any)
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.existingId"
                id="existingID"
                placeholder="Enter ID"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.existingId || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="customerId.customerDetails.email"
                id="email"
                placeholder="Enter Email"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.email || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="channel" className="form-label">
                Channel (How did the patient hear about you?)
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.channel"
                id="channel"
                placeholder="Enter Channel"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.channel || ""}
              />
            </div>
          </div>
        </div>

        {/* Additional Contact & Personal Details */}
        <div className="mb-4">
          <h6 className="border-bottom pb-2 mb-3">
            Additional Contact & Personal Details
          </h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="alternateContactNo" className="form-label">
                Alternate Contact No.
              </label>
              <input
                type="tel"
                className="form-control"
                name="customerId.customerDetails.mobile2"
                id="alternateContactNo"
                placeholder="Enter Alternate Number"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.mobile2 || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="occupation" className="form-label">
                Occupation
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.occupation"
                id="occupation"
                placeholder="Enter Occupation"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.occupation || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="educationLevel" className="form-label">
                AadharNumber
              </label>

              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.aadharNumber"
                id="aadharNumber"
                placeholder="Enter Aadhar Number"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.aadharNumber || ""}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="emergencyContactNo" className="form-label">
                Emergency Contact Number
              </label>
              <input
                type="tel"
                className="form-control"
                name="customerId.customerDetails.mobileNo"
                id="emergencyContactNo"
                placeholder="Enter Number"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.mobileNo || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="coAddress" className="form-label">
                Care Of Address
              </label>
              <textarea
                name="customerId.customerDetails.co"
                className="form-control"
                id="coAddress"
                placeholder="Enter Address"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.co || ""}
                rows="3"
              />
            </div>
          </div>
        </div>

        {/* Emergency Contact Section */}
        {/* <div className="mb-4">
          <h6 className="border-bottom pb-2 mb-3">Emergency Contact</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="emergencyContactName" className="form-label">
                Emergency Contact Name
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.emergencyContactName"
                id="emergencyContactName"
                placeholder="Enter Name"
                onChange={handleChange}
                value={
                  user?.customerId?.customerDetails?.emergencyContactName || ""
                }
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="emergencyContactNo" className="form-label">
                Emergency Contact Number
              </label>
              <input
                type="tel"
                className="form-control"
                name="customerId.customerDetails.mobileNo"
                id="emergencyContactNo"
                placeholder="Enter Number"
                onChange={handleChange}
                value={user?.customerId?.customerDetails?.mobileNo || ""}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="emergencyContactRelation" className="form-label">
                Relationship
              </label>
              <input
                type="text"
                className="form-control"
                name="customerId.customerDetails.emergencyContactRelation"
                id="emergencyContactRelation"
                placeholder="Enter Relationship"
                onChange={handleChange}
                value={
                  user?.customerId?.customerDetails?.emergencyContactRelation ||
                  ""
                }
              />
            </div>
          </div>
        </div> */}

        {/* Form Actions */}
        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={() => window.history.back()}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Save Information
          </button>
        </div>
      </div>
    </div>
  );
};
